export default __webpack_public_path__ + "static/media/table4seat.ab85d9ed.svg";